import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabPanel from '../../../presentational/TabPanel';
import NewInstructionIssuedApprovalTab from './components/NewInstructionIssuedApprovalTab';
import TotalNewInstructionComparisonTab from './components/TotalNewInstructionComparisonTab';
import MostFrequentClientsTab from './components/MostFrequentClientsTab';
import CasesPerCasualtyTypeTab from './components/CasesPerCasualtyTypeTab';
import IssuedApprovalTotalComparisonTab from './components/IssuedApprovalTotalComparisonTab';

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
    minWidth: '150px',
  },
  tabRoot: {
    alignItems: 'flex-start',
  },
  tabWrapper: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    textAlign: 'left',
  },
  tabContent: {
    flexGrow: 1,
    padding: theme.spacing(2),
  },
  breadcrumb: {
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
}));

export default function ApprovalCharts() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="row main-content">
      <div className="col-12 px-lg-5">
        <h2 className={`page-title ${classes.title}`}>Approval Charts</h2>
        <nav aria-label="breadcrumb" className={classes.breadcrumb}>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li> 
            <li className="breadcrumb-item active" aria-current="page">
              Approval Charts
            </li>
          </ol>
        </nav>

        <div className={classes.root}>
          {/* Vertical Tabs */}
          <Tabs
            value={value}
            onChange={handleChange}
            orientation="vertical"
            variant="scrollable"
            indicatorColor="primary"
            textColor="primary"
            className={classes.tabs}
          >
            <Tab label="New Instruction & Issued Approval" {...a11yProps(0)} classes={{ root: classes.tabRoot, wrapper: classes.tabWrapper }} />
            <Tab label="Total New Instruction Approval" {...a11yProps(1)} classes={{ root: classes.tabRoot, wrapper: classes.tabWrapper }} />
            <Tab label="Our Most Frequent Clients" {...a11yProps(2)} classes={{ root: classes.tabRoot, wrapper: classes.tabWrapper }} />
            <Tab label="Cases Approval per Casualty" {...a11yProps(3)} classes={{ root: classes.tabRoot, wrapper: classes.tabWrapper }} />
            <Tab label="Total Issued Approval Comparison" {...a11yProps(10)} classes={{ root: classes.tabRoot, wrapper: classes.tabWrapper }} />
          </Tabs>

          {/* Tab Panels */}
          <div className={classes.tabContent}>
            {value === 0 && (
              <TabPanel value={value} index={0} title="New Instruction & Issued Approval ( Year )">
                <NewInstructionIssuedApprovalTab />
              </TabPanel>
            )}
            {value === 1 && (
              <TabPanel value={value} index={1} title="Total New Instruction Approval ( Year 1 & Year 2 )">
                <TotalNewInstructionComparisonTab />
              </TabPanel>
            )}
            {value === 2 && (
              <TabPanel value={value} index={2} title="Our Most Frequent Clients ( Year )">
                <MostFrequentClientsTab />
              </TabPanel>
            )}
            {value === 3 && (
              <TabPanel value={value} index={3} title="Cases Approval per Casualty in ( Year ) ">
                <CasesPerCasualtyTypeTab />
              </TabPanel>
            )}
            {value === 4 && (
              <TabPanel value={value} index={4} title="Total Issued Approval Comparison ( Year 1 & Year 2 )">
                <IssuedApprovalTotalComparisonTab />
              </TabPanel>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

